import * as React from 'react';

const VerticalDots16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 15a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 15M8 4A1.5 1.5 0 1 1 8.001.999 1.5 1.5 0 0 1 8 4m0 5.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8 9.5"
  }
));
VerticalDots16.Size = 16;
VerticalDots16.Title = "VerticalDots";

export { VerticalDots16 as default };
